export default function FinalCTA() {
  return (
    <section className="relative min-h-[450px] flex items-center justify-center bg-[#272727]">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[300px] bg-[#4d4d31]/25 rounded-full blur-[100px] pointer-events-none"></div>
      <div className="relative z-10 text-center px-6">
        <h2 className="font-antonio text-5xl lg:text-6xl font-bold text-[#e9eae4] mb-6 uppercase">
          Start Getting Trend Intelligence
        </h2>
        <p className="font-barlow text-2xl text-[#e9eae4]/65 mb-12 tracking-wide">
          Every Thursday in your inbox
        </p>
        <a
          href="https://theboloreport.substack.com/subscribe?utm_source=menu&simple=true&next=https%3A%2F%2Ftheboloreport.substack.com%2F"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block bg-[#e9eae4] text-[#272727] px-10 py-5 rounded-full text-lg font-bold hover:bg-white transition-all hover:-translate-y-1 whitespace-nowrap cursor-pointer font-barlow tracking-wide"
        >
          Subscribe on Substack
        </a>
      </div>
    </section>
  );
}
